//
// payloadWithMsAgo
//
// A payload built with eventCapturedAt (performance.now() at the user's action) leaves with
// msAgo instead: the delay to the moment the request is sent, which the server subtracts from
// its own clock to time the event.
//

const payloadWithMsAgo = (payload) => {
  const { eventCapturedAt, ...rest } = payload ?? {};

  if (eventCapturedAt === undefined) return payload;

  return {
    ...rest,
    msAgo: Math.max(0, Math.round(performance.now() - eventCapturedAt)),
  };
};

export default payloadWithMsAgo;
